import React from 'react';

import { ErrorMessage } from '@eika/attention-message';
import { IconTypes } from '@eika/icon';

import { BlockReorderLoader, Piwik, SiteCoreDictionary } from '../types';

import './ErrorDisplay.scss';

interface Props {
    blockReorderLoader: BlockReorderLoader;
    dictionary: SiteCoreDictionary;
    piwik: Piwik | undefined;
}

const ErrorDisplay = ({ blockReorderLoader, dictionary, piwik }: Props) => {
    const { failedHardBlockingCard } = blockReorderLoader;
    const { blockError } = dictionary;

    if (!failedHardBlockingCard) {
        return null;
    }

    return (
        <div
            className="error-display"
            data-track-id={piwik?.blockCardForm?.hardBlockCardError?.dataTrackId}
            data-track-linkname={piwik?.blockCardForm?.hardBlockCardError?.dataTrackLinkname}
            id={piwik?.blockCardForm?.hardBlockCardError?.dataTrackId}
        >
            <ErrorMessage className="inline-error-box" text={blockError} icon={IconTypes.LUKK_24} />
        </div>
    );
};

export default ErrorDisplay;
